import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Volume2, VolumeX } from "lucide-react";
import { isSoundEnabled, setSoundEnabled, playSaveChime } from "@/lib/sound";

export const SoundsCard = () => {
  const [enabled, setEnabled] = useState(isSoundEnabled());

  const handleToggle = (checked) => {
    setEnabled(checked);
    setSoundEnabled(checked);
    // Play a sample sound immediately if turning on (user gesture unlocks audio)
    if (checked) playSaveChime();
  };

  return (
    <Card className="border border-border shadow-sm rounded-sm" data-testid="sounds-card">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-base sm:text-lg flex items-center gap-2">
          {enabled ? <Volume2 className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}
          Suoni interni
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-xs sm:text-sm text-muted-foreground">
          Piccoli feedback sonori quando registri, salvi un check-in o ricevi un errore.
          I suoni delle notifiche push sono gestiti dal sistema operativo del tuo telefono.
        </p>
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium">{enabled ? "Attivi" : "Disattivati"}</p>
            <p className="text-xs text-muted-foreground">
              {enabled ? "Sentirai un piccolo ding" : "Silenzio totale dentro l'app"}
            </p>
          </div>
          <Switch
            checked={enabled}
            onCheckedChange={handleToggle}
            data-testid="sounds-toggle"
          />
        </div>
        {enabled && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => playSaveChime()}
            className="w-full"
            data-testid="sounds-test-btn"
          >
            Prova suono
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
